import { render, staticRenderFns } from "./CarrosselStepInformacoes.vue?vue&type=template&id=21e23b06&scoped=true&"
import script from "./CarrosselStepInformacoes.vue?vue&type=script&lang=js&"
export * from "./CarrosselStepInformacoes.vue?vue&type=script&lang=js&"
import style0 from "./CarrosselStepInformacoes.vue?vue&type=style&index=0&id=21e23b06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e23b06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
